import { render, staticRenderFns } from "./MatchingLocationsOutputChart.vue?vue&type=template&id=744a1b6a&scoped=true&"
import script from "./MatchingLocationsOutputChart.vue?vue&type=script&lang=ts&"
export * from "./MatchingLocationsOutputChart.vue?vue&type=script&lang=ts&"
import style0 from "./MatchingLocationsOutputChart.vue?vue&type=style&index=0&id=744a1b6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a1b6a",
  null
  
)

export default component.exports